module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/vhand7-69716448749783f3c76b505437cf4eca.jpg";